import React from 'react'
import PropTypes from 'prop-types'
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  ReferenceLine,
  LabelList
} from 'recharts'

const propTypes = {
  data: PropTypes.array,
  target: PropTypes.number,
}

const defaultProps = {}

function SimpleBarChart ({ data, target }) {
  return (
    <div>
      <BarChart width={ 600 } height={ 450 } data={ data } barSize={ 30 } barGap={ 20 }>
        <CartesianGrid strokeDasharray="0" stroke="#5EA292" vertical={ false } />
        <XAxis tick={{ fill: '#FFFFFF' }} dataKey="name" />
        <ReferenceLine strokeWidth={ 5 } y={ target } stroke="#DB6333" />
        <Bar dataKey="north" fill="#A8A942">
          <LabelList dataKey="north" position="top" />
        </Bar>
      </BarChart>
    </div>
  )
}

SimpleBarChart.propTypes = propTypes

SimpleBarChart.defaultProps = defaultProps

export default SimpleBarChart
